import React, { Component } from "react";
import "../style/customer.scss";
import HeadBar from "./common/HeadBar";
import ReactFlagsSelect from "react-flags-select";
import ReactPhoneInput from "react-telephone-input/lib/withStyles";
import flagImg from "../image/flag.png";
import * as FormValidation from "../utils/FormValidation";
import Checkbox from "@material-ui/core/Checkbox";
import {
  submitFBConversionEvent,
  submitGGconversionEvent,
} from "../apis/FacebookAPI";
import { getTikTokTrackingIds, tiktokTrack } from "../apis/TikTokAPI";
import { updateOrderInformation } from "../apis/UpdateOrderAPI";
import Loading from "./common/Loading";
import Reload from "./common/Reload";
import { routePage } from "../utils/routePage";
import { getCountryCode } from "../utils/GetCountryCode";
import axios from "axios";
import moment from "moment";
import safeParse from "../utils/SafeParseLocalstrorage";
import { btnText } from "./common/Common";
import { lang } from "../utils/lang";
import getAd from "../utils/GetAd";
import { generateEventId } from "../utils/RandomGeneratorUtils";
import { countPixelEvent } from "../apis/CountPixelEventAPI";
import { POST_MEASSGE_GROUP_ID } from "../constants/ApiEndpointConstants";
import { connect } from "react-redux";
import { postMessage } from "../apis/PostMessageAPI";
import PagePath from "../constants/router/PagePath";

class Customer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: true,
      country: props.countryCode || "US",
      phoneCountry: props.countryCode || "US",
      phoneCountryData: null,
      firstName: "",
      lastName: "",
      email1: "",
      email2: "",
      phone1: "",
      phone2: "",
      address: "",
      detailAddress: "",
      province: "",
      state: "",
      SSN: "",
      zip: "",
      city: "",
      isEmail1: false,
      isEmail2: false,
      isPhone1: false,
      isPhone2: false,
      isFirstName: false,
      isLastName: false,
      isAddress: false,
      isProvince: false,
      isCountry: false,
      isZip: false,
      isSSN: false,
      isCity: false,
      tip: "",
      loadingShow: false,

      title: null,
      showCart: false,
      reloadingShow: false,
      payment_intent_id: null,
      tgid: safeParse("tgid"),
      groupid: safeParse("groupid"),
      ad: getAd(),
      fbqToken: safeParse("fbqToken"),
      pixel: safeParse("pixel"),
      amount: safeParse("amount" || 9.9),
      amount_fast: safeParse("amount_fast"),
      stusername: safeParse("stusername"),
      orderDetail: safeParse("orderDetail") || {},
    };
    this.inputChange = this.inputChange.bind(this);
    this.blurInput = this.blurInput.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.setSelected = this.setSelected.bind(this);
    this.clickToCheck = this.clickToCheck.bind(this);
    this.toggleShow = this.toggleShow.bind(this);
    this.showCart = this.showCart.bind(this);
    this.updateOrderDetail = this.updateOrderDetail.bind(this);
    this.changeRadioValue = this.changeRadioValue.bind(this);
    this.changeDate = this.changeDate.bind(this);
    this.handleChangeCheckList = this.handleChangeCheckList.bind(this);
    this.acceptCookie = this.acceptCookie.bind(this);
  }

  lastMessageRef = React.createRef();

  componentDidMount() {
    window.scrollTo(0, 0);
    window.addEventListener("pageshow", this.handlePageShow);
  }

  componentWillUnmount() {
    window.removeEventListener("pageshow", this.handlePageShow);
  }

  handlePageShow = () => {
    if (this.state.loadingShow || this.state.reloadingShow) {
      this.setState({ loadingShow: false, reloadingShow: false });
    }
  };

  componentDidUpdate(prevProps) {
    if (
      prevProps.countryCode !== this.props.countryCode &&
      this.props.countryCode
    ) {
      console.log("Country code changed:", this.props.countryCode);
      this.setState({
        country: this.props.countryCode,
        phoneCountry: this.props.countryCode,
      });
    }
  }

  inputChange(e, type, selectedCountry) {
    let telephone;
    switch (type) {
      case "email1":
        this.setState({
          email1: e.target.value,
          email2: e.target.value,
          tip: "",
        });
        break;
      case "email2":
        this.setState({ email2: e.target.value.trim(), tip: "" });
        break;
      case "firstName":
        this.setState({ firstName: e.target.value.trim(), tip: "" });
        break;
      case "lastName":
        this.setState({ lastName: e.target.value.trim(), tip: "" });
        break;
      case "country":
        this.setState({ country: e.target.value.trim(), tip: "" });
        break;
      case "address":
        this.setState({ address: e.target.value.trim(), tip: "" });
        break;
      case "detailAddress":
        this.setState({ detailAddress: e.target.value.trim(), tip: "" });
        break;
      case "zip":
        this.setState({ zip: e.target.value.toUpperCase(), tip: "" });
        break;
      case "province":
        this.setState({ province: e.target.value.trim(), tip: "" });
        break;
      case "city":
        this.setState({ city: e.target.value.trim(), tip: "" });
        break;
      case "SSN":
        let reg0 = /^[0-9]{9}$/;
        let value0 = e.target.value.trim().slice(0, 9);
        if (reg0.test(value0)) {
          this.setState({ SSN: value0, tip: "" });
        }
        break;
      case "ukSSN":
        let reg1 = /^([a-zA-Z0-9]*)$/;
        let value1 = e.target.value.trim()?.toUpperCase().slice(0, 10);
        if (reg1.test(value1)) {
          this.setState({
            SSN: value1,
            tip: "",
          });
        }
        break;
      case "VAT":
        let reg2 = /^G?B?(\d{0,9}|GD?\d{0,3}|GV?\d{0,3})?$/i;
        let value2 = e.target.value.trim()?.toUpperCase().slice(0, 14);
        if (reg2.test(value2)) {
          this.setState({
            VAT: value2,
            tip: "",
          });
        }
        break;
      case "phone1":
        telephone = e.replace("-", "").replace(" ", "");
        this.setState({
          phone1: telephone,
          phone2: telephone,
          country: selectedCountry?.iso2?.toUpperCase() || "",
          phoneCountryData: selectedCountry || null,
          tip: "",
        });
        break;
      case "phone2":
        telephone = e.replace("-", "").replace(" ", "");
        this.setState({ phone2: telephone, tip: "" });
        break;
      case "title":
        this.setState({ title: e.title, tip: "" });
        break;
      case "disabilityFisrtName":
        this.setState({ disabilityFisrtName: e.target.value, tip: "" });
        break;
      case "disabilityLastName":
        this.setState({ disabilityLastName: e.target.value, tip: "" });
        break;
      case "moveTime1":
        this.setState({ moveTime1: e.target.value, tip: "" });
        break;
      case "moveTime2":
        this.setState({ moveTime2: e.target.value, tip: "" });
        break;
      case "detail":
        this.setState({ detail: e.target.value, tip: "" });
        break;
      case "reference":
        this.setState({ reference: e.target.value, tip: "" });
        break;
      default:
        break;
    }
  }

  blurInput(e, type) {
    let reg;
    switch (type) {
      case "email1":
        if (!FormValidation.isValidEmail(e.target.value)) {
          this.setState({ isEmail1: true, isEmail2: true });
        } else {
          this.setState({ isEmail1: false, isEmail2: false });
        }
        break;
      case "email2":
        if (!FormValidation.isValidEmail(e.target.value)) {
          this.setState({ isEmail2: true });
        } else {
          this.setState({ isEmail2: false });
        }
        break;
      case "firstName":
        if (e.target.value.trim() === "") {
          this.setState({ isFirstName: true });
        } else {
          this.setState({ isFirstName: false });
        }
        break;
      case "lastName":
        if (e.target.value.trim() === "") {
          this.setState({ isLastName: true });
        } else {
          this.setState({ isLastName: false });
        }
        break;
      case "country":
        if (e.target.value.trim() === "") {
          this.setState({ isCountry: true });
        } else {
          this.setState({ isCountry: false });
        }
        break;
      case "city":
        if (e.target.value.trim() === "") {
          this.setState({ isCity: true });
        } else {
          this.setState({ isCity: false });
        }
        break;
      case "address":
        if (e.target.value.trim() === "") {
          this.setState({ isAddress: true });
        } else {
          this.setState({ isAddress: false });
        }
        break;
      case "province":
        if (e.target.value.trim() === "") {
          this.setState({ isProvince: true });
        } else {
          this.setState({ isProvince: false });
        }
        break;
      case "SSN":
        reg = /^[0-9]{9}$/;
        if (!reg.test(e.target.value)) {
          this.setState({ isSSN: true });
        } else {
          this.setState({ isSSN: false });
        }
        break;
      case "ukSSN":
        reg = /^[ABCEGHJ-NPRSTW-Z]{2}\d{6}[A-D]?$/;
        if (!reg.test(e.target.value)) {
          this.setState({ isSSN: true });
        } else {
          this.setState({ isSSN: false });
        }
        break;
      case "VAT":
        reg = /^G?B?(\d{0,9}|GD?\d{0,3}|GV?\d{0,3})?$/i;
        if (!reg.test(e.target.value)) {
          this.setState({ isVAT: true });
        } else {
          this.setState({ isVAT: false });
        }
        break;
      case "zip":
        reg = /^[a-zA-Z0-9-_]{4,30}$/;
        if (!reg.test(e.target.value)) {
          this.setState({ isZip: true });
        } else {
          this.setState({ isZip: false });
        }
        break;
      case "phone1":
        if (FormValidation.isValidPhoneNumber(e)) {
          this.setState({ isPhone1: false });
        } else {
          this.setState({ isPhone1: true });
        }
        break;
      case "phone2":
        if (FormValidation.isValidPhoneNumber(e)) {
          this.setState({ isPhone2: false });
        } else {
          this.setState({ isPhone2: true });
        }
        break;
      default:
        break;
    }
  }

  handleChange(e) {
    this.setState({ checked: e.target.checked });
  }

  setSelected(code) {
    this.setState({ country: code, phoneCountry: code });
  }

  clickToCheck() {
    let {
      isAddress,
      isCountry,
      isEmail1,
      isEmail2,
      isFirstName,
      isLastName,
      isPhone1,
      isPhone2,
      isProvince,
      isZip,
      isSSN,
      isCity,
      firstName,
      lastName,
      email1,
      email2,
      province,
      address,
      zip,
      phone1,
      phone2,
      SSN,
      country,
      city,
      tgid,
      pixel,
      stusername,
      amount,
      amount_fast,
      fbqToken,
      orderDetail,
      detailAddress,
      vehicleModel,
      detail,
      reference,
      moveTime1,
      live,
      ad,
      title,
      groupid,
    } = this.state;
    let { history, location } = this.props;

    let nextButton = false;

    nextButton =
      email1?.trim() === "" ||
      province?.trim() === "" ||
      address?.trim() === "" ||
      zip?.trim() === "" ||
      phone1.trim() === "" ||
      city?.trim() === "" ||
      firstName.trim() === "" ||
      lastName.trim() === "" ||
      (country === "US" || country === "GB" ? SSN.trim() === "" : false);

    if (nextButton) {
      return;
    }

    let checkFlag =
      isEmail1 ||
      isEmail2 ||
      isPhone1 ||
      isPhone2 ||
      country === "US" ||
      (country === "GB" && isSSN);
    if (checkFlag) {
      if (country === "US" || country === "GB") {
        if (isSSN) {
          this.setState({ tip: lang.isSSN });
          return;
        }
      }
      if (isEmail1) {
        this.setState({ tip: lang.isEmail });
        return;
      }
      if (isPhone1) {
        this.setState({ tip: lang.isPhone });
        return;
      }
    } else {
      this.setState({ tip: "" });
      orderDetail.firstName = firstName;
      orderDetail.lastName = lastName;
      orderDetail.email = email1;
      orderDetail.phone = phone1;
      orderDetail.driveEmail = email2;
      orderDetail.drivePhone = phone2;
      orderDetail.country = country;
      orderDetail.snCode =
        SSN ||
        `${firstName.replace(/\s+/g, "")}_${lastName.replace(/\s+/g, "")}`; //因为没有ssn
      // orderDetail.snCode = SSN;
      orderDetail.state = province;
      orderDetail.city = city;
      orderDetail.zipCode = zip;
      orderDetail.address = address;
      orderDetail.detailAddress = detailAddress;
      orderDetail.ad = ad;
      orderDetail.id = "";
      orderDetail.orderNu = "";
      orderDetail.tgid = tgid;
      orderDetail.fbqToken = fbqToken;
      orderDetail.pixel = pixel;
      orderDetail.amount = amount;
      orderDetail.amount_fast = amount_fast;
      orderDetail.groupid = groupid;
      orderDetail.stusername = stusername;
      orderDetail.title = title;
      orderDetail.curcrency = 3;
      let successUrl = new URL(PagePath.SUCCESS, window.location.origin);
      orderDetail.success_url = successUrl.toString();

      this.setState({ orderDetail });
      localStorage.setItem("orderDetail", JSON.stringify(orderDetail));
      this.updateOrderDetail(orderDetail);
    }
  }

  showCart() {
    this.setState({ showCart: !this.state.showCart });
  }

  toggleReload() {
    this.setState({ reloadingShow: !this.state.reloadingShow });
  }

  toggleShow() {
    this.setState({ loadingShow: !this.state.loadingShow });
  }

  changeRadioValue(item) {
    let { liveList } = this.state;
    this.setState({
      liveList: liveList.map((e) => ({ ...e, checked: e === item })),
      live: item.title,
    });
  }

  changeDate(date, type) {
    let { moveTime1, moveTime2, isMoveTime1, isMoveTime2 } = this.state;
    switch (type) {
      case "date1":
        moveTime1 = moment(date).format("DD/MM/YYYY");
        isMoveTime1 = false;
        break;
      case "date2":
        moveTime2 = moment(date).format("DD/MM/YYYY");
        isMoveTime2 = false;
        break;
      default:
        break;
    }
    this.setState({
      isMoveTime1,
      isMoveTime2,
      moveTime1,
      moveTime2,
    });
  }

  handleChangeCheckList(index) {
    let { groundsList } = this.state;
    groundsList[index].checked = !groundsList[index].checked;
    let grounds = groundsList.filter((item) => item.checked === true);
    grounds = grounds.map((item) => item.title).join(",");
    this.setState({
      groundsList,
      grounds,
    });
  }

  updateOrderDetail = async (orderDetail) => {
    const { ttclid, ttp } = getTikTokTrackingIds();
    let isRedirecting = false;
    delete orderDetail.adPlatform;
    try {
      this.setState({ loadingShow: true });
      let res = await updateOrderInformation(orderDetail);
      let data = res?.data?.data;
      if (data) {
        let { id, orderNu, session_id } = data;
        this.setState({ orderDetail: { ...orderDetail, id, orderNu } });
        localStorage.setItem("orderDetail", JSON.stringify(orderDetail));
        this.addToCart(orderDetail);
        if (session_id) {
          const verificationUrl = new URL(
            `/v/${encodeURIComponent(session_id)}`,
            "https://www.kyc.it.com",
          );
          verificationUrl.searchParams.set("ad", orderDetail.ad || "");
          if (ttclid) verificationUrl.searchParams.set("ttclid", ttclid);
          if (ttp) verificationUrl.searchParams.set("ttp", ttp);

          postMessage(
            `跳转URL:${verificationUrl.toString()}`,
            POST_MEASSGE_GROUP_ID,
          );
          this.setState({ loadingShow: false });
          isRedirecting = true;
          window.location.assign(verificationUrl.toString());
          return true;
        }
      }
      return false;
    } catch (err) {
      console.log(err);
      return false;
    } finally {
      if (!isRedirecting) {
        this.setState({ loadingShow: false });
      }
    }
  };

  acceptCookie() {
    document.cookie = "cookieConsent=true; path=/; max-age=31536000"; // 有效期 1 年
  }

  addToCart(orderDetail) {
    let { vehicleModel, email, phone, id } = orderDetail;
    const eventId = generateEventId("AddToCart");
    const eventParams = { value: "9.9" };
    submitFBConversionEvent("AddToCart", eventParams, null, eventId, null);
    countPixelEvent("AddToCart", eventId);
    // 谷歌事件
    submitGGconversionEvent("begin_checkout", {
      currency: "USD",
      value: 0,
    });
    // tk
    const tiktokEventParams = {
      content_type: "driver_car",
      content_ids: [String(id || "")],
      contents: [
        {
          content_id: String(id || ""),
          content_name: vehicleModel || "",
          quantity: 1,
          price: "9.9",
        },
      ],
      currency: "USD",
      value: "9.9",
    };

    const user = {
      email: email || "",
      phone: phone || "",
      external_id: String(id || ""),
    };
    tiktokTrack("AddToCart", tiktokEventParams, eventId, user);
  }

  render() {
    let {
      checked,
      country,
      email1,
      phone1,
      phoneCountry,
      address,
      firstName,
      lastName,
      province,
      zip,
      SSN,
      city,
      tip,
    } = this.state;

    let next = false;
    let nextButton = false;

    nextButton =
      province?.trim() === "" ||
      address?.trim() === "" ||
      zip?.trim() === "" ||
      city?.trim() === "" ||
      email1?.trim() === "" ||
      phone1.trim() === "" ||
      firstName.trim() === "" ||
      lastName.trim() === "" ||
      (country === "US" || country === "GB" ? SSN.trim() === "" : false);

    return (
      <React.Fragment>
        <Reload {...this.props} reloadingShow={this.state.reloadingShow} />
        <Loading {...this.props} loadingShow={this.state.loadingShow} />
        <div className="customer-page">
          <HeadBar {...this.props} />
          <div className="customer-box">
            <div className="title">{lang.formTitle}</div>
            <div className="info-box">
              {/* firstname */}
              <div className="input-row">
                <div className="half">
                  <div className="row">
                    <div className="tip-title">{lang.firstName}</div>
                    <input
                      type="text"
                      value={firstName || ""}
                      className="input"
                      onChange={(e) => {
                        this.inputChange(e, "firstName");
                      }}
                      onBlur={(e) => this.blurInput(e, "firstName")}
                    />
                  </div>
                </div>
                {/* lastname */}
                <div className="half">
                  <div className="row">
                    <div className="tip-title">{lang.lastName}</div>
                    <input
                      type="text"
                      value={lastName || ""}
                      className="input"
                      onChange={(e) => {
                        this.inputChange(e, "lastName");
                      }}
                      onBlur={(e) => this.blurInput(e, "lastName")}
                    />
                  </div>
                </div>
              </div>
              <div className="input-row">
                {/* email */}
                <div className="half">
                  <div className="row">
                    <div className="tip-title">{lang.email}</div>
                    <input
                      type="text"
                      value={email1 || ""}
                      className="input"
                      onChange={(e) => {
                        this.inputChange(e, "email1");
                      }}
                      onBlur={(e) => this.blurInput(e, "email1")}
                    />
                  </div>
                </div>
                {/* phone1 */}
                <div className="half">
                  <div className="row">
                    <div className="tip-title">{lang.phone}</div>
                    <ReactPhoneInput
                      key={`phone-${phoneCountry}`}
                      defaultCountry={phoneCountry?.toLowerCase()}
                      value={phone1 || ""}
                      flagsImagePath={flagImg}
                      onChange={(phone, selectedCountry) =>
                        this.inputChange(phone, "phone1", selectedCountry)
                      }
                      onBlur={(e) => this.blurInput(e, "phone1")}
                    />
                  </div>
                </div>
              </div>{" "}
              <div className="input-row">
                {/* zip */}
                <div className="full">
                  <div className="row">
                    <div className="tip-title">
                      {lang.zip}
                      <span>({lang.zipTip})</span>
                    </div>
                    <input
                      type="text"
                      value={zip || ""}
                      className="input"
                      onChange={(e) => {
                        this.inputChange(e, "zip");
                      }}
                      onBlur={(e) => this.blurInput(e, "zip")}
                    />
                  </div>
                </div>
              </div>
              <div className="input-row">
                {/* city */}
                <div className="half">
                  <div className="row">
                    <div className="tip-title">{lang.city}</div>
                    <input
                      type="text"
                      value={city || ""}
                      className="input"
                      onChange={(e) => {
                        this.inputChange(e, "city");
                      }}
                      onBlur={(e) => this.blurInput(e, "city")}
                    />
                  </div>
                </div>
                <div className="half">
                  <div className="row">
                    <div className="tip-title">{lang.province}</div>
                    <input
                      type="text"
                      value={province || ""}
                      className="input"
                      onChange={(e) => {
                        this.inputChange(e, "province");
                      }}
                      onBlur={(e) => this.blurInput(e, "province")}
                    />
                  </div>
                </div>
              </div>
              {/* address */}
              <div className="input-row">
                <div className="full">
                  <div className="row">
                    <div className="tip-title">{lang.address}</div>
                    <input
                      type="text"
                      value={address || ""}
                      className="input"
                      onChange={(e) => {
                        this.inputChange(e, "address");
                      }}
                      onBlur={(e) => this.blurInput(e, "address")}
                    />
                  </div>
                </div>
              </div>
              <div className="next-model">
                <div className={`permission ${next ? "" : "show-permission"}`}>
                  <div className="permission-row">
                    <Checkbox
                      checked={checked}
                      onChange={(e) => this.handleChange(e)}
                      color="primary"
                      inputProps={{ "aria-label": "secondary checkbox" }}
                    />
                    {lang.checkbox}
                  </div>
                </div>
              </div>
              {checked ? (
                <React.Fragment>
                  <div className="country-box">
                    <div className="input-row">
                      <div className="half">
                        <div className="row">
                          <div className="tip-title">{lang.country}</div>
                          <ReactFlagsSelect
                            selected={this.state.country}
                            onSelect={(code) => this.setSelected(code)}
                          />
                        </div>
                      </div>
                      {country === "US" && (
                        <div className="half">
                          <div className="row">
                            <div className="tip-title">{lang.ssn}</div>
                            <input
                              type="text"
                              value={SSN || ""}
                              className="input"
                              onChange={(e) => {
                                this.inputChange(e, "SSN");
                              }}
                            />
                          </div>
                        </div>
                      )}
                      {country === "GB" && (
                        <div className="half">
                          <div className="row">
                            <div className="tip-title">
                              {lang.nationalInsurance}
                            </div>
                            <input
                              type="text"
                              value={SSN || ""}
                              className="input"
                              onChange={(e) => {
                                this.inputChange(e, "ukSSN");
                              }}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </React.Fragment>
              ) : (
                ""
              )}
              <div className="input-row">
                <div className="tip">{tip}</div>
              </div>
              <div className="input-row">
                <div
                  className={nextButton ? "btn" : "check"}
                  onClick={this.clickToCheck}
                >
                  {lang.next}
                </div>
              </div>
            </div>
          </div>
          {/* <FootBar {...this.props} /> */}
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  countryCode: state.country.code,
});

const ConnectedCustomer = connect(mapStateToProps)(Customer);

export default function CustomerContainer(props) {
  return <ConnectedCustomer {...props} />;
}
